<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-input
        v-model="filters.Descripcion"
        :label="'Descripción'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar descripción',
        }"
      ></custom-input>
      <el-col
        :span="4"
        style="margin-left: 2%"
      >
        <custom-select
          v-model="filters.RecursoTipo"
          :label="'Tipo recurso'"
          :settings="{
            // inputClass:{'input-error': !validateResourceFields.RecursoTipo },
            options: recursoTipoList,
          }"
        >
        </custom-select>
      </el-col>
      <el-col :span="2">
        <div class="custom-label">Activo</div>
        <el-switch v-model="filters.Activo" />
      </el-col>
      <el-col
        :span="3"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrar"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import { useRecursoStore } from '@/stores/recurso_store.js';
import { useRecursoTipoStore } from '@/stores/recurso_tipo_store.js';
import { storeToRefs } from 'pinia';
import IconDelete from '~icons/mdi/delete';
const recursoStore = useRecursoStore();
const recursoTipoStore = useRecursoTipoStore();
const { filters } = storeToRefs(recursoStore);
const { setPage, emptyList, resetFilter, findAllRecursoHTTP, resetResource } = recursoStore;
const { recursoTipoList } = storeToRefs(recursoTipoStore);

const filtrar = () => {
  try {
    setPage(1);
    emptyList();
    findAllRecursoHTTP();
    resetResource();
  } catch (error) {
    console.error('Error al filtrar recursos:', error);
  }
};

const LimpiarFiltros = () => {
  setPage(1);
  emptyList();
  resetFilter();
  findAllRecursoHTTP();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
